import { makeAutoObservable } from 'mobx';
import * as goodsService from '@/services/goods';

export class Goods {
  goods = {};

  constructor() {
    makeAutoObservable(this);
  }

  getCategory(params) {
    return goodsService.getCategory(params);
  }

  getSkuList(params) {
    return goodsService.getSkuList(params);
  }

  applySku(params) {
    return goodsService.applySku(params);
  }

  getSkuDetail(params) {
    return goodsService.getSkuDetail(params);
  }

  approvalSku(params) {
    return goodsService.approvalSku(params);
  }

  releaseSku(params) {
    return goodsService.releaseSku(params);
  }

  shelfSku(params) {
    return goodsService.shelfSku(params);
  }

  delSku(params) {
    return goodsService.delSku(params);
  }
  getSupplierSkuList(params) {
    return goodsService.getSupplierSkuList(params);
  }
  getSkuComments(params) {
    return goodsService.getSkuComments(params);
  }
}

export const GOODS = 'goods';
